/* 🤖 this file was generated by svg-to-ts */
export const matIconLocalPolice: {
  name: 'local-police';
  data: string;
} = {
  name: 'local-police',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m14.5 12.59.9 3.88-3.4-2.05-3.4 2.05.9-3.87-3-2.59 3.96-.34L12 6.02l1.54 3.64 3.96.34-3 2.59zM12 3.19l7 3.11V11c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/></svg>`
};
